import { FunctionComponent, useCallback, useEffect, useState } from 'react';
import { Autocomplete, AutocompleteProps, TextStyle } from '@shopify/polaris';
import styled from 'styled-components';

const EmptyStateContainer = styled.div`
  text-align: center;
  padding: 1rem;
  font-style: italic;
`;

const emptyState = (
  <EmptyStateContainer>
    <TextStyle>No results found</TextStyle>
  </EmptyStateContainer>
);

const AutocompleteInput: FunctionComponent<AutocompleteProps> = (props) => {
  const { onSelect, options, selected, textField, ...inputProps } = props;
  const [selectedValues, setSelectedValues] = useState(selected);

  const handleOnSelect = useCallback(
    (updatedSelected) => {
      setSelectedValues(updatedSelected);
      onSelect(updatedSelected);
    },
    [onSelect],
  );

  useEffect(() => {
    setSelectedValues(selected);
  }, [selected]);

  return (
    <Autocomplete
      {...inputProps}
      options={options}
      selected={selectedValues}
      onSelect={handleOnSelect}
      textField={textField}
      emptyState={emptyState}
    />
  );
};

export default AutocompleteInput;
